<h2 *ngIf="departmentSelected" class="first_title">Gestione dipartimento {{departmentSelected.name}}</h2>
<div export-help></div>
<app-pathbar-lem [pathbars]="pathbars"></app-pathbar-lem>

<div class="standardpanel">

  <div class="row block">
    <div class="col-sm-12">
      <div class="panel panel-default">
        <div class="panel-heading">Info societarie</div>
        <div class="panel-body">
          <h5><strong>Società :</strong> {{departmentSelected ? departmentSelected.company.name : ''}}</h5>
          <h5><strong>Dipartimento :</strong> {{departmentSelected ? departmentSelected.description : ''}}</h5>
        </div>
      </div>
    </div>
  </div>

  <div class="row block">
    <div class="col-sm-12">
      <div class="titleblock">
        <h3 class="title1level">
          Gestione Membri
        </h3>
        <p>
          <a (click)="addMembro()" href="javascript:void(0)">
            Associa nuovo membro
            <span class="glyphicon glyphicon-plus-sign"></span>
          </a>
        </p>
      </div>

    </div>
  </div>



  <div class="row">
    <div class="col-sm-12 block-first">
      <div class="row" style="margin-bottom: 20px;">
        <div class="col-sm-6 col-xs-6">      
          <b><span class="ml-info">Responsabili di dipartimento :</span></b>
        </div>
        <div class="col-sm-6 col-xs-6" style="text-align: end;">
          <a (click)="refreshResponsible()" class="update-icon" href="javascript:void(0)">
            Aggiorna
            <span class="glyphicon glyphicon-refresh"></span>
          </a>
        </div>
      </div>

      <app-members-list [pagable] = "pagableResponsables"
                        (finish) = "onFinish($event)"
                        (delete)="onDelete($event)"
                        (edit)="onEdit($event)"
                        (transfer)="onTransfer($event)"
                        [members] = "responsibles"
                        (refreshEvent)="refreshResponsible($event)"
      ></app-members-list>
    </div>
    <div class="col-sm-12 block">
      <div class="row" style="margin-bottom: 20px;">
        <div class="col-xs-6 col-sm-6">
          <b><span class="ml-info">Membri di dipartimento :</span></b>
        </div>
        <div class="col-xs-6 col-sm-6" style="text-align: end;">
          <a (click)="refreshMembers()" class="update-icon" href="javascript:void(0)">
            Aggiorna
            <span class="glyphicon glyphicon-refresh"></span>
          </a>
        </div>
      </div>
      <app-members-list [pagable] = "pagableMembers"
                        (finish)="onFinish($event)"
                        (delete)="onDelete($event)"
                        (edit)="onEdit($event)"
                        (transfer)="onTransfer($event)"
                        [members] = "members"
                        (refreshEvent)="refreshMembers($event)"
      ></app-members-list>
  </div>
</div>
